import { defineComponent, shallowRef, ref, useTemplateRef, openBlock, createElementBlock, Fragment, createVNode, unref, withCtx, createTextVNode, normalizeStyle, createElementVNode } from 'vue';
import _sfc_main$1 from '../../../component/dialog/dialog.vue.js';
import '@ssml-editor/core';
import { Button } from '@ssml-editor/vue';
import { ElSlider } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import { useElementBounding } from '../../../node_modules/.pnpm/@vueuse_core@14.2.1_vue@3.5.31_typescript@5.9.3_/node_modules/@vueuse/core/dist/index.js';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                               */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
import { BreakMenuService } from './break-menu-service.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "break-menu",
  props: {
    editor: {}
  },
  setup(__props) {
    const breakMenuService = shallowRef();
    const popoverVisible = ref(false);
    const time = ref(50);
    const margin = ref("");
    const menuBarButtonRef = useTemplateRef("menu-bar-button");
    const { x, y, height } = useElementBounding(menuBarButtonRef);
    function show() {
      margin.value = `${y.value + height.value}px 0 0 ${x.value}px`;
      popoverVisible.value = true;
    }
    function hide() {
      popoverVisible.value = false;
    }
    function menuClickHandler() {
      if (__props.editor) {
        breakMenuService.value ??= new BreakMenuService(__props.editor);
        if (!breakMenuService.value.isDisabled()) {
          show();
        }
      }
    }
    function submitHandler() {
      breakMenuService.value?.setNode(time.value);
      hide();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(Button), {
          ref: "menu-bar-button",
          "icon-class": "iconfont-ssml-editor icon-ssml-editor-tingdun",
          onClick: menuClickHandler
        }, {
          default: withCtx(() => [
            createTextVNode("插入停顿")
          ]),
          _: 1
        }, 512),
        createVNode(unref(_sfc_main$1), {
          title: "插入停顿",
          width: "400",
          "show-close": false,
          "destroy-on-close": true,
          modelValue: popoverVisible.value,
          "onUpdate:modelValue": ($event) => popoverVisible.value = $event,
          style: normalizeStyle({ margin: margin.value }),
          onSubmit: submitHandler
        }, {
          default: withCtx(() => [
            createElementVNode("div", { class: "se-break" }, [
              createVNode(unref(ElSlider), {
                "show-input": "",
                size: "small",
                modelValue: time.value,
                "onUpdate:modelValue": ($event) => time.value = $event,
                min: 50,
                max: 1e4
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "style"])
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=break-menu.vue2.js.map
